module.exports = __webpack_public_path__ + "img/bg_3.66c9f8a1.png";